// FCA requirements for fin prom compliance
// UK will no longer be able to view these urls
// https://gemini-spaceship.atlassian.net/browse/CX-1981
// NOTE: If updating this list, please update middleware.ts as well since middleware does not all spread operators
export const blockedUrls = [
  "/affiliate-program",
  "/affiliate-program/tr",
  "/affiliate-program/vn",
  "/apac/australia",
  "/apac/singapore",
  "/artemis/legal",
  "/artemis/legal/6billion-pepe-giveaway-promotion-official-rules",
  "/artemis/legal/incentive-contest-official-rules",
  "/awkward-astronauts",
  "/credit-card",
  "/derivatives",
  "/eu",
  "/fees/derivative-fees-table",
  "/gifting",
  "/legal/gemini-credit-card-spend-promotion",
  "/legal/gemini-earn-program-terms-and-authorization-agreement",
  "/legal/gemini-newmoneymondays-$100ETH",
  "/legal/gemini-newmoneymondays-$2500ETH",
  "/legal/gemini-newmoneymondays-$250ETH",
  "/legal/gemini-newmoneymondays-$500BTC",
  "/legal/gemini-newmoneymondays-$500ETH",
  "/legal/gemini-newmoneymondays-1ETH",
  "/legal/gemini-newmoneymondays-3SwagBoxes",
  "/legal/gemini-newmoneymondays-awkwardastronauts",
  "/legal/gemini-newmoneymondays-BryanBrinkman",
  "/legal/gemini-newmoneymondays-creatureworld",
  "/legal/gemini-newmoneymondays-loserclub",
  "/legal/gemini-newmoneymondays-soundblock.1",
  "/legal/gemini-newmoneymondays-stephcrigler",
  "/legal/gemini-newmoneymondays-stijnorlans",
  "/legal/gemini-referral-rewards-program-terms",
  "/legal/gifting-terms-and-conditions",
  "/legal/ie-promotional-terms-and-conditions",
  "/legal/master-loan-agreement",
  "/legal/mastercard-benefits-gemini-credit-card",
  "/legal/nifty-nft-airdrop-terms-and-conditions",
  "/legal/pepe-giveaway-100users",
  "/legal/pepe-rips-nft-terms-and-conditions",
  "/legal/promotional-terms-and-conditions",
  "/legal/staking-agreement",
  "/legal/uk-promotional-terms-and-conditions",
  "/legal/cardholder-agreement",
  "/legal/credit-card-rewards-agreement",
  "/opportunity-fund",
  "/partners",
  "/pdf",
  "/products",
  "/referral-club",
  "/promo/cryptober",
  "/leaderboard",
  "/card",
  "/samsung",
  "/cryptopedia/airdrop-crypto-giveaway-uniswap",
  "/cryptopedia/ax-coin-avalanche-crypto-ava-labs",
  "/cryptopedia/tcoin-ira-crypto-ira-how-to-buy-crypto-with-ira",
  "/cryptopedia/edit-card-vs-debit-card-crypto-credit-card-brands",
  "/cryptopedia/ypto-401k-crypto-ira-bitcoin-retirement-account",
  "/cryptopedia/yptocurrency-derivatives-trading-synthetic-assets",
  "/cryptopedia/gecoin-joke-cryptocurrency",
  "/cryptopedia/rn-interest-on-crypto-interest-account-crypto-lending"
];
